/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentGroupStandingList = {
    type: 'array',
    contains: {
        type: 'TournamentGroupStanding',
    },
} as const;
